export default function auth({ next, to }) {
  try {
    let currentUser = JSON.parse(localStorage.getItem('currentUser'))
    if (!currentUser || !currentUser.token) {
      localStorage.removeItem('currentUser')
      return next({
        name: 'Login',
        params: { showMsjInvalidToken: 'false' },
        query: { redirect: to.fullPath },
      })
    }
    if (isTokenExpired(currentUser.token)) {
      localStorage.removeItem('currentUser')
      return next({
        name: 'Login',
        params: { showMsjInvalidToken: 'false' },
        query: { redirect: to.fullPath },
      })
    }
  } catch (error) {
    localStorage.removeItem('currentUser')
    return next({
      name: 'Login',
      params: { showMsjInvalidToken: 'false' },
    })
  }
  return next()
}

function isTokenExpired(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    return payload.exp < Date.now() / 1000
  } catch {
    return true
  }
}
